import { on } from '@/hooks'
import { dispatchSelf } from '@/events'

on('request', ({ options }) => {
    // Echo reports `undefined` until its socket is connected, and the header then travels as the
    // literal "undefined" — which Pusher rejects (`Invalid socket ID undefined`) as soon as a
    // broadcast calls `toOthers()`. While the socket isn't connected there is nothing to exclude,
    // so send nothing: the broadcast simply reaches everyone, the sender included.
    if (window.Echo && window.Echo.socketId()) {
        options.headers['X-Socket-ID'] = window.Echo.socketId()
    }
})

/* Pembersih milik fitur ECHO, dipisah dari `component.cleanups`.
   Daftar di komponen itu dipakai bersama listener DOM (`supportListeners`), `$wire.$watch`, dan
   `$wire.$cleanup`; membersihkannya borongan akan ikut mematikan milik fitur lain. */
let echoCleanups = new WeakMap()

/* Komponen yang sudah menitipkan satu pembersih ke daftar bersama — supaya langganan echo ikut
   dilepas saat komponennya dibongkar, tanpa menumpuk satu entri setiap kali daftar dikirim ulang. */
let teardownRegistered = new WeakSet()

function addEchoCleanup(component, fn) {
    let list = echoCleanups.get(component) || []

    list.push(fn)

    echoCleanups.set(component, list)
}

/* Lepas seluruh langganan echo komponen ini. Dipanggil sebelum memasang daftar yang baru (nama
   listener bisa berubah tanpa komponennya dipasang ulang) dan saat komponennya dibongkar. */
function clearEchoListeners(component) {
    (echoCleanups.get(component) || []).forEach(fn => {
        try { fn() } catch (e) { /* pembersihan tidak boleh menggagalkan pemasangan baru */ }
    })

    echoCleanups.set(component, [])
}

on('effect', ({ component, effects }) => {
    let listeners = []

    if (Object.prototype.hasOwnProperty.call(effects, 'listeners') && effects.listeners) {
        listeners = effects.listeners
    }

    /* Lepas listener lama HANYA bila muatan ini memang membawa daftar listener baru.
     *
     * Efek lain juga melewati hook ini — misalnya potongan island yang dikirim saat pesan masuk, yang
     * isinya cuma gelembung baru tanpa daftar listener. Membersihkan langganan di situ mematikan
     * langganan pesan itu sendiri, dan gejalanya bergantian: pesan pertama masuk, pesan kedua tidak,
     * pesan ketiga masuk lagi — karena tiap pesan memicu satu efek yang membersihkan langganannya. */
    if (Object.prototype.hasOwnProperty.call(effects, 'listeners')) {
        clearEchoListeners(component)
    }

    if (! teardownRegistered.has(component)) {
        teardownRegistered.add(component)

        component.addCleanup(() => clearEchoListeners(component))
    }

    listeners.forEach(event => {
        if (event.startsWith('echo')) {
            if (typeof window.Echo === 'undefined') {
                console.warn('Laravel Echo cannot be found')

                return
            }

            let event_parts = event.split(/(echo:|echo-)|:|,/)

            if (event_parts[1] == 'echo:') {
                event_parts.splice(2, 0, 'channel', undefined)
            }

            if (event_parts[2] == 'notification') {
                event_parts.push(undefined, undefined)
            }

            let [
                s1,
                signature,
                channel_type,
                s2,
                channel,
                s3,
                event_name,
            ] = event_parts

            if (['channel', 'private', 'encryptedPrivate'].includes(channel_type)) {
                let handler = e => dispatchSelf(component, event, [e])

                window.Echo[channel_type](channel).listen(event_name, handler)

                addEchoCleanup(component, () => {
                    window.Echo[channel_type](channel).stopListening(event_name, handler)
                })
            } else if (channel_type == 'presence') {
                if (['here', 'joining', 'leaving'].includes(event_name)) {
                    window.Echo.join(channel)[event_name](e => {
                        dispatchSelf(component, event, [e])
                    })

                    addEchoCleanup(component, () => {
                        window.Echo.leave(channel)
                    })
                } else{
                    let handler = e => dispatchSelf(component, event, [e])

                    window.Echo.join(channel).listen(event_name, handler)

                    addEchoCleanup(component, () => {
                        window.Echo.leave(channel)
                    })
                }
            } else if (channel_type == 'notification') {
                window.Echo.private(channel).notification(notification => {
                    dispatchSelf(component, event, [notification])
                })

                addEchoCleanup(component, () => {
                    window.Echo.private(channel).stopListening('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated')
                })
            } else {
                console.warn('Echo channel type not yet supported')
            }
        }
    })
})
